module.exports = __webpack_public_path__ + "media/images/badges/cyclebar/grey/RideClub_Milestones_App_750-Grey-fc95633eb37a811cd2294333331c87b1.png";